// extracted by mini-css-extract-plugin
export default {"app":"app-oo7_W","panelOpen":"panelOpen-bqPDf"};